import CiudadanoStats from "../CiudadanoStats/CiudadanoStats";
import CiudadanoCertificados from "../CiudadanoCertificados/CiudadanoCertificados";
import { FaPaperPlane, FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function CitizenDashboard() {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col gap-[25px]">
            <div className="flex justify-end gap-[15px]">
                <button
                    className="flex h-[42px] min-w-[180px] cursor-pointer items-center justify-center gap-[10px] rounded-[10px] border-none bg-[#E5E7EB] px-5 font-semibold text-primary transition-all duration-300 hover:bg-primary hover:text-white"
                    onClick={() => navigate("/emisiones")}
                >
                    <FaPaperPlane />
                    Emitir Certificado
                </button>
                <button
                    className="flex h-[42px] min-w-[180px] cursor-pointer items-center justify-center gap-[10px] rounded-[10px] border-none bg-[#E5E7EB] px-5 font-semibold text-primary transition-all duration-300 hover:bg-primary hover:text-white"
                    onClick={() => navigate("/validacioncert")}
                >
                    <FaShieldAlt />
                    Validar Certificado
                </button>
            </div>

            <CiudadanoStats />

            <div className="gap-[25px]">
                <CiudadanoCertificados />
            </div>
        </div>
    );
}

export default CitizenDashboard;
